import { render, staticRenderFns } from "./SupportChatHeadOverflow.vue?vue&type=template&id=0c0b1bf6&"
import script from "./SupportChatHeadOverflow.vue?vue&type=script&lang=ts&"
export * from "./SupportChatHeadOverflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports